import { getClients, getTrialInfo } from '@/lib/knots-api'
import { useSuspenseQuery } from '@tanstack/react-query'
import { ApiRoutes } from '@/config/routes'

export const useGetTrialInfo = (moduleName: string) =>
  useSuspenseQuery({
    queryKey: [ApiRoutes.getTrialInfo, moduleName],
    queryFn: () => getTrialInfo({ filters: { module: { name: moduleName } } }),
  })

export const useGetActiveStudioClients = () =>
  useSuspenseQuery({
    queryKey: [ApiRoutes.getClients, 'studio_basic'],
    queryFn: () => getClients({ filters: { module: { name: 'studio_basic' }, active: true } }),
  })
